import {gql} from '@apollo/client'

export const GET_ALL_VENTAS = gql`
  query saleList(
    $after: String
    $id: Float
    $offset: Int
    $quarryId: Float
    $clientId: Float
    $created_Gt: DateTime
    $created_Gte: DateTime
    $created_Lt: DateTime
    $created_Lte: DateTime
  ) {
    saleList(
      offset: $offset
      after: $after
      id: $id
      quarry_Id: $quarryId
      client_Id: $clientId
      created_Gt: $created_Gt
      created_Gte: $created_Gte
      created_Lt: $created_Lt
      created_Lte: $created_Lte
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          invoiceId
          client {
            name
          }
          products {
            edges {
              node {
                name
              }
            }
          }
          saleTotal
          saleType
          status
        }
      }
    }
  }
`
export const GET_CLIENTS_FILTER_VENTAS = gql`
  query clientList($after: String, $id: Float, $name: String, $nit: String) {
    clientList(after: $after, id: $id, name_Iexact: $name, nit: $nit) {
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`
export const GET_CLIENTS_CREATE_VENTAS = gql`
  query clientList($after: String, $id: Float, $name: String, $nit: String) {
    clientList(after: $after, id: $id, name_Iexact: $name, nit: $nit) {
      edges {
        cursor
        node {
          id
          name
          nit
          postpaidSales
        }
      }
    }
  }
`
export const GET_CANTERAS_CREATE_VENTAS = gql`
  query quarryList($after: String, $id: Float, $offset: Int) {
    quarryList(after: $after, id: $id, offset: $offset) {
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`
export const GET_PRODUCTS_CREATE_VENTAS = gql`
  query productList($after: String, $id: Float, $name: String) {
    productList(after: $after, id: $id, name_Iexact: $name) {
      edges {
        cursor
        node {
          id
          name
          unitPrice
          promotion
          clientproductpriceSet {
            edges {
              node {
                id
                price
                client {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`
export const GET_ONE_VENTA = gql`
  query saleList($id: Float) {
    saleList(id: $id) {
      edges {
        cursor
        node {
          id
          saleTotal
          saleType
          status
          observations
          created
          totalSaleInWords
          invoiceId
          salelogSet {
            edges {
              node {
                id
                description
                created
                user {
                  id
                  firstName
                  lastName
                  email
                }
              }
            }
          }
          dispatchSet {
            edges {
              node {
                id
                created
                plate
                departureDatetime
                dispatchedBy
                observations
                uuid
                product {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
                delivery {
                  id
                  date
                  totalTravel
                  responsible
                }
              }
            }
          }
          quarry {
            id
            name
            phoneNumber
          }
          client {
            name
            nit
            phoneNumber
            postpaidSales
          }
          user {
            id
            firstName
            lastName
          }
          saleproductthroughSet {
            edges {
              node {
                id
                units
                price
                promotion
                product {
                  id
                  name
                  unitType
                  unitPrice
                }
              }
            }
          }
        }
      }
    }
  }
`
export const GET_VENTA_EDIT = gql`
  query saleList($id: Float) {
    saleList(id: $id) {
      edges {
        cursor
        node {
          id
          saleTotal
          saleType
          observations
          status
          quarry {
            id
            name
            phoneNumber
          }
          client {
            id
            name
            nit
            phoneNumber
            postpaidSales
          }
          saleproductthroughSet {
            edges {
              node {
                id
                units
                price
                promotion
                product {
                  id
                  name
                  unitType
                  unitPrice
                }
              }
            }
          }
        }
      }
    }
  }
`
